import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import i18next from 'i18next';
import { createBox } from '@famly/mf_layout_box';
import { Stack } from '@famly/mf_layout_stack';
import { Text } from '@famly/mf_data-display_text';
import { Toggle } from '@famly/mf_input_toggle';
import { kinderConnectCaptureSettingsChildToggleE2eClass } from './kinder-connect-capture-settings-e2e-ids';
// `clip`/absolute positioning has no system-prop equivalent. Toggle's `label` prop is required with
// no separate aria-label, so this hides the label text while still giving the toggle an accessible name.
const VisuallyHiddenLabel = styled(createBox({
    component: 'span',
    position: 'absolute',
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
})) `
    padding: 0;
    margin: -1px;
    clip: rect(0, 0, 0, 0);
    border: 0;
`;
/**
 * The matched children, one row per child with their room as a subtitle and a toggle for the
 * capture setting.
 */
export const KinderConnectCaptureSettingsChildrenListRows = ({ matchedChildren, toggleState, isDisabled, onToggle, }) => (_jsx(_Fragment, { children: matchedChildren.map(child => {
        var _a;
        return (_jsxs(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", py: 2, children: [_jsxs(Stack, { direction: "column", minWidth: 0, children: [_jsx(Text, { variant: "body", emphasized: true, children: child.name }), _jsx(Text, { variant: "body-small", color: "n300", children: child.roomName })] }), _jsx(Toggle, { checked: (_a = toggleState[child.id]) !== null && _a !== void 0 ? _a : false, onChange: checked => onToggle(child.id, checked), disabled: isDisabled, 
                    // "end" avoids MUI's default marginRight: -11px, which "start" (the
                    // default) leaves in place and clips the switch against the row edge.
                    labelPlacement: "end", label: _jsx(VisuallyHiddenLabel, { children: i18next.t($ => $.stat.kinderConnectCapture.businessLogic.src.translations.json.settings
                            .toggleLabel, { name: child.name }) }), "data-e2e-class": kinderConnectCaptureSettingsChildToggleE2eClass })] }, child.id));
    }) }));
